import { onError } from "@apollo/client/link/error";
import { ApolloLink } from "@apollo/client";
import _ from "lodash";

const CONSOLE_GROUP_STYLE =
  "color: white; font-weight: normal; background-color: darkred; padding: 3px 6px";

const getErrorHandler = (name: string): ApolloLink => {
  const handler = (message, errorData) => {
    console.group(`%c[${name} graphql error] ${message}`, CONSOLE_GROUP_STYLE);
    console.log("Error Details: ", errorData);
    console.groupEnd();
  };
  return onError(err => {
    let errName = "unknown";
    if (err?.graphQLErrors?.length) {
      errName = err.graphQLErrors.map(i => i.message).join(", ");
    } else if (err?.networkError) {
      errName = `${err.networkError.name} ${err.networkError.message}`;
    }

    let errData: any = err;
    try {
      JSON.stringify(err);
    } catch (cyclicError) {
      errData = undefined;
    }

    handler(errName, errData);
  });
};

export const graphqlErrorToMessage = (prefix: string, err: any) => {
  console.dir(err);
  const name = _.get(err, "networkError.name", "Unknown Server Error");
  return `${prefix}: "${name}"`;
};

export default getErrorHandler;
